import React from 'react';
import { ShieldCheck, Lock, Globe, Server, CheckCircle2, AlertCircle } from 'lucide-react';
import './SecurityCompliance.css';

const SSLCertificates = () => {
  return (
    <div className="security-page">
      <section className="hero-section">
        <div className="hero-content">
          <div className="hero-copy">
            <div className="status-badge">
              <Lock size={14} /> Encrypted Connection
            </div>
            <h1>Premium SSL Certificates for Total Protection</h1>
            <p>
              Secure your website, protect user data, and boost your SEO rankings 
              with industry-standard 256-bit encryption.
            </p>
            <div className="hero-actions">
              <a className="button primary" href="#contact">Install SSL Now</a>
              <a className="button secondary" href="#plans">View Certificates</a>
            </div>
          </div>
          <div className="hero-panel">
            <div className="panel-card panel-glow lock-animation">
              <ShieldCheck className="icon" size={48} />
              <h3>A+ Rating</h3>
              <p>Achieve the highest level of security ranking for your web enterprise.</p>
            </div>
          </div>
        </div>
      </section>

      <section id="plans" className="section">
        <div className="section-heading">
          <span className="eyebrow">Enterprise Trust</span>
          <h2>Encryption levels for every business.</h2>
          <p>From single domain blogs to multi-site enterprise networks, we provide the certificate that fits your architecture.</p>
        </div>

        <div className="security-grid">
          <div className="security-card">
            <div className="sec-icon"><Globe size={24} /></div>
            <h3>DV Certificates</h3>
            <p>Domain Validation for blogs and small business sites. Ready in minutes with automated renewal.</p>
          </div>
          <div className="security-card">
            <div className="sec-icon"><Server size={24} /></div>
            <h3>OV Certificates</h3>
            <p>Organization Validation featuring verified company details for e-commerce and login portals.</p>
          </div>
          <div className="security-card">
            <div className="sec-icon"><ShieldCheck size={24} /></div>
            <h3>EV Certificates</h3>
            <p>Extended Validation providing the highest tier of trust with the green address bar indicator.</p>
          </div>
        </div>
      </section>

      <section className="section bg-glass">
        <div className="feature-block">
          <div className="solution-copy">
            <span className="eyebrow">Why SSL Matters</span>
            <h2>More than just a padlock icon.</h2>
            <p>
              SSL certificates are mandatory for modern web applications. They prevent 
              man-in-the-middle attacks and ensure data integrity between users and servers.
            </p>
            <div className="checker-grid">
              <div className="check-item"><CheckCircle2 size={16} /> HTTP/2 Enabled</div>
              <div className="check-item"><CheckCircle2 size={16} /> SEO Advantage</div>
              <div className="check-item"><CheckCircle2 size={16} /> PCI Compliance</div>
              <div className="check-item"><CheckCircle2 size={16} /> Browser Trust</div>
            </div>
          </div>
          <div className="encryption-visual">
            <Lock className="lock-animation" size={120} color="#10b981" />
          </div>
        </div>
      </section>

      <section className="cta-section">
        <div className="cta-content">
          <h2>Your site is not secure without SSL.</h2>
          <p>Don't let your visitors see "Not Secure" warnings. Get protected today.</p>
          <a className="button primary" href="#contact">Protect My Site</a>
        </div>
      </section>
    </div>
  );
};

export default SSLCertificates;
